import React from "react";

let HamburgerButton = React.createClass({
    getInitialState() {
        return {};
    },
    propTypes: {
        handleClick: React.PropTypes.func.isRequired,
        showClose: React.PropTypes.bool.isRequired
    },
    render() {
        return (
            <button className={["eo-hamburger-btn icon", (this.props.showClose ? "eo-icon-close" : "eo-icon-menu")].join(" ")}
                    onClick={this.props.handleClick}></button>
        );
    }
});

export default HamburgerButton;



/** WEBPACK FOOTER **
 ** ./app/utils/components/HamburgerButton.js
 **/